import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { normalizeRichTextValue, richTextToPlainText } from '../../utils/richText';
import './RichText.css';

const RichTextContent = forwardRef(({ value = '', className = '' }, ref) => {
  const html = normalizeRichTextValue(value);
  if (!richTextToPlainText(html)) return null;

  return (
    <div
      ref={ref}
      className={`gm-rich-text ${className}`.trim()}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
});

RichTextContent.displayName = 'RichTextContent';

RichTextContent.propTypes = {
  value: PropTypes.string,
  className: PropTypes.string,
};

export default RichTextContent;

